export default "__VITE_PUBLIC_ASSET__57f70fb8__"